import React from 'react';
import styled from 'styled-components';
import ArticleCard from './ArticleCard';
import colors from '../theme/colors';
import { Article } from '../services/api';

interface ArticlesListProps {
  articles: Article[];
  loading?: boolean;
  error?: string | null;
}

const Container = styled.div`
  width: 100%;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 3rem;
  font-size: 1.1rem;
  color: ${colors.textGray};
`;

const ErrorMessage = styled.div`
  text-align: center;
  padding: 3rem;
  color: ${colors.mainOrange};
  background-color: ${colors.goldGrey};
  border: 2px solid ${colors.mainOrange};
  border-radius: 8px;
  margin: 2rem 0;
`;

const EmptyMessage = styled.div`
  text-align: center;
  padding: 3rem;
  font-size: 1.1rem;
  color: ${colors.textGray};
`;

const ArticlesList: React.FC<ArticlesListProps> = ({ articles, loading, error }) => {
  if (loading) {
    return (
      <Container>
        <LoadingMessage>Завантаження статей...</LoadingMessage>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <ErrorMessage>{error}</ErrorMessage>
      </Container>
    );
  }

  if (!articles || articles.length === 0) {
    return (
      <Container>
        <EmptyMessage>Статті не знайдено</EmptyMessage>
      </Container>
    );
  }

  return (
    <Container>
      <Grid>
        {articles.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </Grid>
    </Container>
  );
};

export default ArticlesList;



